import { render } from "./newspage.vue?vue&type=template&id=3905bf0d&scoped=true"
import script from "./newspage.vue?vue&type=script&lang=js"
export * from "./newspage.vue?vue&type=script&lang=js"

import "./newspage.vue?vue&type=style&index=0&id=3905bf0d&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3905bf0d"]])

export default __exports__